<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-07 17:34:36
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-11-11 14:44:23
-->
<template>
  <ux-form
    class="swagger x-border-50 x-margin x-height-100"
    ref="form"
    :colon="true"
    :rules="rules"
    label-width="56px"
    :data="formData"
    data-automation="swagger"
    @close="close"
    @confirm="confirm"
    :confirmText="$t('HT.swagger.inspect')"
  >
    <ux-form-item :label="$t('HT.router.api.groupList')" labelWidth="auto" required prop="groupId">
      <ux-select
        v-model="formData.groupId"
        class="select"
        :options="apiList"
        :props="{ label: 'name', value: 'id' }"
      ></ux-select>
      <ux-checkbox v-model="formData.coverDecide">{{ $t('HT.swagger.coverDecide') }}</ux-checkbox>
    </ux-form-item>
    <ux-form-item label="swagger" labelWidth="auto" required start prop="remark">
      <ux-input
        v-model="formData.remark"
        type="textarea"
        :autosize="{ minRows: 25, maxRows: 25 }"
        resize="none"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        groupId: '', //apiId
        coverDecide: false //是否勾选覆盖
      },
      apiList: [], //api分组集合
      rules: this.$rul.swagger()
    };
  },

  mounted() {
    this.getGroups();
  },

  methods: {
    /**
     * 查询API分组
     */
    getGroups(params) {
      this.$api.api.getGroups(params).then((res) => {
        if (res.code == 10000) {
          this.apiList = res.data;
        }
      });
    },

    /**
     * 取消回调
     */
    close() {
      this.$router.push('/apiList');
    },

    /**
     * 确认回调
     */
    confirm() {
      this.checkSwagger(this.formData.remark);
    },
    /**
     * 导入swagger
     * @param {Object} params 表单提交参数
     */
    impSwagger(params) {
      this.$api.api.impSwagger(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.importSuccess'));
          this.$router.push('/apiList');
        }
      });
    },

    /**
     * 检查swagger
     * @param {Object} params 表单提交参数
     */
    checkSwagger(params) {
      this.$api.api
        .checkSwagger(params)
        .then((res) => {
          if (res.code == 10000) {
            const title = this.$t('HT.swagger.checkSwagger.title');
            this.$uxModal.show({
              title,
              confirm: () => {
                this.impSwagger(this.formData);
              }
            });
          }
        })
        .catch(() => {
          this.$uxModal.hide();
          this.$uxMessage.error(this.$t('HT.swagger.formatError'));
        });
    }
  }
};
</script>

<style lang="scss">
.swagger {
  padding: 20px 30px;

  .select {
    width: 300px;
    margin-right: 40px;
  }
}
</style>
